/** @type {import("../../../../../../common/AbstractTable/StyledTable").ColumnDef[]} */
const OrderStatusHistoryColDefs = [
  { dataKey: 'status', displayTitle: 'Status' },
  { dataKey: 'statusSetAt', displayTitle: 'Timestamp' },
  { dataKey: 'triggeringAction', displayTitle: 'Caused by' }
]

export default OrderStatusHistoryColDefs
